import _ from 'lodash';
import * as types from '../actions/actionTypes';
import * as treeUtils from '../components/common/DynamicTree/DynamicTreeUtils';

const splitExpression = expression => {
  const trimed = expression.trim();
  let replaceBrackets = trimed.replace(/\(|\)/g, ' ');
  replaceBrackets = replaceBrackets.trim();
  replaceBrackets = replaceBrackets.replace(/ OR /g, ' ');
  replaceBrackets = replaceBrackets.replace(/ AND /g, ' ');
  const splits = replaceBrackets.split(' ');
  const splitedData = splits.filter(e => e);
  return _.uniq(splitedData);
};

const activeTargetingCrieteria = (qtsKeywords, expression, defaultExpression) => {
  let qtsFilteredKeywords = [];
  const splitedData = expression && splitExpression(expression);
  qtsFilteredKeywords = _.map(qtsKeywords, parent => {
    const children = _.map(parent.children, child => {
      let isActive = false;
      let isSelected = false;
      const splitKeyword = child.keyword.split(', ');
      if (splitedData) {
        _.map(splitKeyword, chldKeyWord => {
          _.map(splitedData, keyword => {
            if (chldKeyWord === keyword && defaultExpression === expression) {
              isSelected = true;
              isActive = true;
            }
          });
        });
      }
      return { ...child,
        isSelected,
        isActive,
      };
    });
    return { ...parent,
      children,
    };
  });
  return qtsFilteredKeywords;
};

const getGroupedKeywords = keywords => {
  const sortedKeywords = _.orderBy(keywords, o => o.questionOrderId, ['asc']);
  const groupedKeywords = _.groupBy(sortedKeywords, 'questionText');
  const groupedobj = {};
  Object.keys(groupedKeywords).map(item => {
    const ordered = _.orderBy(groupedKeywords[item], o => o.optionOrderId, ['asc']);
    const mappedKeywordObj = _.map(ordered, keyword => {
      return {
        keyword: keyword.keyword,
        title: keyword.optionText,
      };
    });
    groupedobj[item] = mappedKeywordObj;
    return false;
  });
  return groupedobj;
};

const customizeKeywords = keywords => {
  if (!keywords || _.isEmpty(keywords.data)) {
    return [];
  }
  const sortedGroupedKeywords = getGroupedKeywords(keywords.data);
  const keyWordWithParent = [];
  const updatedKeyword = [];
  _.map(sortedGroupedKeywords, (child, key) => {
    const parent = {
      shortText: key,
      rectype: 'C',
      children: child,
    };
    keyWordWithParent.push(parent);
  });

  let childNodeId = 0;
  _.map(keyWordWithParent, (item, i) => {
    const children = _.map(item.children, child => {
      const childData = {
        ...child,
        isActive: false,
        isSelected: false,
        node: childNodeId,
        rectype: 'Q',
        parentNode: i,
      };
      childNodeId += 1;
      return childData;
    });

    updatedKeyword.push({ ...item,
      node: i,
      children,
    });
  });
  // const myOrderedArray = _.sortBy(updatedKeyword, 'shortText');
  return updatedKeyword;
};


const initialState = {
  surveyGizmoLoginURL: '',
  qtsSurveyList: [{}],
  qtsSelectedStudy: undefined,
  qtsViewTypes: 'PROJECT_LISTNG',
  surveyGizmoLoggedIn: false,
  currentSurveySampleEdited: false,
  isEditSurvery: false,
  qtsKeywords: [],
  selectedQtsExpressions: '',
  currentNewSurveyExpression: '',
  removeRowItem: {},
  editSurveyClick: false,
  editSurveyId: '',
  currentEditSurveryUserId: '',
  isDefaultExpression: true,
  qtsFeasabilityExpression: undefined,
  targetingCriteria: '',
  currentSurveyDetail: {},
  isRowDeleting: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.QTS_GET_SURVEYGIZMO_LOGIN_URL:
      {
        return {
          ...state,
          surveyGizmoLoginURL: action.payload !== undefined
            && action.payload.loginLink !== undefined ?
            action.payload.loginLink :
            '',
          surveyGizmoApiKey: action.payload !== undefined
            && action.payload.apiKey !== undefined ?
            action.payload.apiKey :
            undefined,
          surveyGizmoApiSecret: action.payload !== undefined
            && action.payload.apiSecret !== undefined ?
            action.payload.apiSecret :
            undefined,
        };
      }
    case types.QTS_GET_SURVEY_LIST:
      {
        return {
          ...state,
          qtsSurveyList: action.payload !== undefined &&
            action.payload.data.length !== undefined ?
            action.payload.data :
            state.qtsSurveyList,
          currentSurveyDetail: {},
        };
      }
    case types.QTS_PING_TEST:
      {
        return {
          ...state,
          qtsPingResponse: action.payload,
        };
      }
    case types.GET_QTS_REPORTS_DICTIONARY_TREE_LOAD:
      {
        if (action.nodeID !== 0) {
          const deepTreeCopy = treeUtils.getDeepTreeCopy(
            state.qtsDictionaryTree.data,
          );
          const data = treeUtils.updateTreeNode(
            deepTreeCopy, {
              children: action.payload.data,
            },
            action.nodeID,
          );

          return {
            ...state,
            qtsDictionaryTree: {
              ...state.qtsDictionaryTree,
              data,
            },
          };
        }
        return {
          ...state,
          qtsDictionaryTree: action.payload,
        };
      }
    case types.QTS_VIEW_TYPE:
      {
        return {
          ...state,
          qtsViewTypes: action.payload,
        };
      }
    case types.QTS_SELECTED_STUDY:
      {
        return {
          ...state,
          qtsSelectedStudy: action.payload,
        };
      }
    case types.QTS_GET_SURVEY_QUESTIONS:
      {
        return {
          ...state,
          qtsSurveyQuestions: action.payload.data === undefined ? [] : action.payload.data,
        };
      }
    case types.QTS_GET_SURVEY_OPTIONS:
      {
        return {
          ...state,
          qtsSurveyOptions: action.payload.data === undefined ? [] : action.payload.data,
        };
      }
    case types.UPDATE_QTS_DICTIONARY_QO:
      {
        return {
          ...state,
          qtsDisctionaryQuestionAndOptions: action.payload,
        };
      }
    case types.QTS_SURVEY_GIZMO_LOGGEDIN:
      {
        return {
          ...state,
          surveyGizmoLoggedIn: action.payload,
        };
      }
    case types.QTS_NEW_SURVEY_NAME:
      {
        return {
          ...state,
          currentNewSurveyName: action.payload.surveyName,
          currentNewSurveyLength: action.payload.surveyLength,
          currentNewSurveyIR: action.payload.ir,
          currentNewSurveySample: action.payload.sample,
          currentNewSurveyExpression: action.payload.expression,
          currentNewSurveyCost: action.payload.cost,
          currentNewSurveyCategoryExpanded: action.payload.categoryExpanded,
          currentNewSurveySelectedCatagories: action.payload.selectedCategories,
          currentNewSurveyRows: action.payload.rows,
        };
      }
    case types.QTS_SURVEY_SUBMIT_APPROVAL:
      {
        return {
          ...state,
          currentNewSuveySubimitted: action.payload.data === {},
        };
      }
    case types.QTS_SURVEY_INFO_SAMPLE_EDITED:
      {
        return {
          ...state,
          currentSurveySampleEdited: action.payload,
        };
      }
    case types.UPDATE_QTS_SURVEY:
      {
        return {
          ...state,
          currentEditSurveryUserId: '',
        };
      }
    case types.QTS_CLEAR_SURVEY:
      {
        if (action.payload !== undefined && action.payload === true) {
          return {
            ...state,
            currentNewSurveyName: undefined,
            currentNewSurveyLength: undefined,
            currentNewSurveyIR: undefined,
            currentNewSurveySample: undefined,
            currentNewSurveyExpression: '',
            currentNewSurveyCost: undefined,
            currentNewSurveyCategoryExpanded: undefined,
            currentNewSurveySelectedCatagories: undefined,
            currentNewSurveyRows: undefined,
            qtsSurveyList: [{}],
            qtsFeasability: undefined,
            qtsSimmonsSurveyId: undefined,
            qtsProdigyProjectId: undefined,
            qtsProdigyQuotaId: undefined,
            gizmoSurveyid: undefined,
            qtsGizmoQuestionSaved: undefined,
            qtsGzmoIdForSurvey: undefined,
            qtsFeasabilityExpression: undefined,
            qtsSurveyQuestions: undefined,
            qtsSurveyOptions: [],
            qtsSelectedStudy: undefined,
            qtsViewTypes: 'PROJECT_LISTNG',
            qtsFetchedIR: undefined,
            qtsFetchedIRExpression: undefined,
            isEditSurvery: false,
            currentEditSurveryUserId: '',
            currentEditAccountId: undefined,
            qtsKeywords: [],
            removeRowItem: {},
            editSurveyId: '',
            isDefaultExpression: true,
            targetingCriteria: '',
            currentSurveyDetail: {},
            isRowDeleting: false,
            prodigyMap: {},
          };
        }
        return {
          ...state,
          currentNewSurveyName: undefined,
          currentNewSurveyLength: undefined,
          currentNewSurveyIR: undefined,
          currentNewSurveySample: undefined,
          currentNewSurveyExpression: '',
          currentNewSurveyCost: undefined,
          currentNewSurveyCategoryExpanded: undefined,
          currentNewSurveySelectedCatagories: undefined,
          currentNewSurveyRows: undefined,
          qtsFeasability: undefined,
          qtsSimmonsSurveyId: undefined,
          qtsProdigyProjectId: undefined,
          qtsProdigyQuotaId: undefined,
          gizmoSurveyid: undefined,
          qtsGizmoQuestionSaved: undefined,
          qtsGzmoIdForSurvey: undefined,
          qtsFeasabilityExpression: undefined,
          qtsSurveyQuestions: [],
          qtsSurveyOptions: [],
          qtsSelectedStudy: undefined,
          qtsViewTypes: 'PROJECT_LISTNG',
          qtsFetchedIR: undefined,
          qtsFetchedIRExpression: undefined,
          isEditSurvery: false,
          currentEditSurveryUserId: '',
          currentEditAccountId: undefined,
          qtsKeywords: [],
          removeRowItem: {},
          editSurveyId: '',
          isDefaultExpression: true,
          targetingCriteria: '',
          currentSurveyDetail: {},
          isRowDeleting: false,
          prodigyMap: {},
        };
      }
    case types.QTS_FETCH_IR:
      {
        return {
          ...state,
          qtsFetchedIR: action.payload,
          qtsFetchedIRExpression: action.expression,
          qtsKeywords: activeTargetingCrieteria(
            state.qtsKeywords,
            action.expression,
            action.defaultExpression
          ),
          currentNewSurveyExpression: action.defaultExpression ? action.expression : '',
          isDefaultExpression: false,
        };
      }
    case types.QTS_CREATE_SIMMONS_PROJECT:
      {
        return {
          ...state,
          qtsSimmonsSurveyId: action.surveyid,
          currentEditSurveryUserId: '',
        };
      }
    case types.QTS_CREATE_PRODIGY_PROJECT:
      {
        return {
          ...state,
          qtsProdigyProjectId: action.payload.prodege_project_id,
          gizmoSurveyid: action.gizmoSurveyId,
          qtsGzmoIdForSurvey: action.gizmoSurveyId,
          qtsFeasabilityExpression: undefined,
        };
      }
    case types.SAVE_QTS_GIZMO_QUESTION:
      {
        return {
          ...state,
          qtsGizmoQuestionSaved: action.payload,
          qtsSurveyQuestions: [],
          qtsSurveyOptions: [],
        };
      }
    case types.QTS_CREATE_PRODIGY_QUOTA:
      {
        return {
          ...state,
          qtsProdigyQuotaId: action.payload,
        };
      }
    case types.QTS_GET_SURVEY:
      {
        return {
          ...state,
          qtsSurveyInfo: action.payload,
          qtsSelectedStudy: action.study,
        };
      }
    case types.GET_QTS_FEASIBILITY_RUN:
      {
        return {
          ...state,
          qtsFeasability: action.payload.data.message,
          qtsFeasabilityExpression: action.payload.prodigyExpression,
          isRowDeleting: action.payload && false,
        };
      }
    case types.QTS_TARGETING_CRIETERIA:
      {
        let payload = action.payload;
        if (typeof payload === 'string') {
          payload = JSON.parse(action.payload);
        }
        const qtsKeywords = customizeKeywords(payload);
        return {
          ...state,
          qtsKeywords,
        };
      }

    case types.QTS_EXPRESSION_LIST:
      {
        return {
          ...state,
          qtsKeywords: activeTargetingCrieteria(
            state.qtsKeywords,
            action.expression,
            action.defaultExpression
          ),
        };
      }
    case types.QTS_SET_TARGETING_CRITERIA:
      {
        return {
          ...state,
          targetingCriteria: action.targetingCriteria,
        };
      }
    case types.QTS_REMOVE_ROW_SELECTION:
      {
        return {
          ...state,
          removeRowItem: action.category,
          targetingCriteria: [],
          isRowDeleting: true,
        };
      }
    case types.QTS_EDIT_SURVEY:
      {
        return {
          ...state,
          editSurveyClick: true,
          editSurveyId: action.surveyid,
        };
      }
    case types.QTS_GET_DEFAULT_SAMPLE:
      {
        return {
          ...state,
          qtsKeywords: [],
          selectedQtsExpressions: '',
          currentNewSurveyExpression: '',
          removeRowItem: {},
          editSurveyClick: false,
          editSurveyId: '',
          currentEditSurveryUserId: '',
          isEditSurvery: false,
          qtsFeasabilityExpression: undefined,
          isRowDeleting: false,
          targetingCriteria: [],
        };
      }
    case types.QTS_RESET_PRODEGE_PROJECT:
      {
        return {
          ...state,
          qtsFeasabilityExpression: undefined,
        };
      }
    case types.QTS_SURVEY_DETAIL_HISTORY:
      {
        return {
          ...state,
          currentSurveyDetail: action.payload,
        };
      }
    case types.QTS_PRODIGGY_MAPPING: {
      return {
        ...state,
        prodigyMap: action.payload.data,
        studyTypeId: action.studyTypeId,
      };
    }
    case types.IE_MRI_STUDIES: {
      const sortedStudies = _.orderBy(action.payload.data, o => new Date(o.fe), ['desc']);
      return {
        ...state,
        ieMRIStudies: sortedStudies,
      };
    }
    case types.QTS_GET_SURVEY_SUCCESS: {
      const { qtsSurveyInfo } = state;
      return {
        ...state,
        qtsGzmoIdForSurvey: qtsSurveyInfo.gizmoSurveyId,
        currentNewSurveyName: qtsSurveyInfo.surveyName,
        currentNewSurveyLength: qtsSurveyInfo.qTSProdegeProject.loi,
        currentNewSurveySample: qtsSurveyInfo.qTSProdegeProject.sample_size,
        currentNewSurveyExpression: qtsSurveyInfo.expression,
        currentEditSurveryUserId: qtsSurveyInfo.userid,
        currentEditAccountId: qtsSurveyInfo.accountid,
        qtsSimmonsSurveyId: qtsSurveyInfo.surveyid,
        qtsProdigyProjectId: qtsSurveyInfo.prodege_project_id,
        gizmoSurveyid: qtsSurveyInfo.gizmoSurveyId,
        editSurveyClick: false,
        isEditSurvery: true,
      };
    }
    case types.RESET_SELECTED_KEYWORDS: {
      return {
        ...state,
        currentNewSurveyExpression: '',
      };
    }
    default:
      return state;
  }
}
